var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('full-calendar',{ref:"calendar",attrs:{"event-sources":_vm.eventSources,"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }